import React, { useCallback, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    BUYER_REGISTRATION_STEPS,
    RegistrationFlowType,
} from "../bidder-registration/constant";
import useTranslationHook from "../../../../hooks/useTranslationHook";
import { useLocation } from "react-router-dom";
import { createPortal } from "react-dom";
import EmsignerIframe from "../../../../common/EmsignerIframe";
import { updateBuyerRegistrationField } from "../../../../../redux/slice/buyerSlice";

const BidderRegistrationAgreementModal = ({ show, onClose }) => {
    const { state } = useLocation();
    const { t } = useTranslationHook();
    const registrationData = useSelector(
        (state) => state.buyer.buyerRegistration
    );
    const registration_id = useSelector(
        (state) => state.buyer.buyerRegistration.registration_id
    );
    const agreementSigned = useSelector(
        (state) => state.buyer.buyerRegistration?.agreementSigned
    );
    const { first_name, last_name } =
        useSelector((state) => state.auth.user) || {};
    const dispatch = useDispatch();

    const {
        selectedSessionID,
        propertyId,
        currentPathName,
        lotID,
        isBidLimitIncrease,
    } = state ?? {};

    const registrationType = registrationData?.registrationType;

    const { firstName, lastName } = useMemo(() => {
        const stepOneData =
            registrationType === RegistrationFlowType.SELF
                ? registrationData?.self?.stepOneData
                : registrationData?.principal?.stepOneData;

        if (stepOneData?.firstName) {
            return {
                firstName: stepOneData.firstName,
                lastName:
                    stepOneData?.lastName !== "NA"
                        ? stepOneData?.lastName || ""
                        : "",
            };
        }

        // Bid-limit-increase skips the doc-collection steps, so stepOneData is
        // never populated — fall back to the logged-in user's own name.
        return { firstName: first_name || "", lastName: last_name || "" };
    }, [registrationData, registrationType, first_name, last_name]);

    const signatureValue = `${firstName} ${lastName}`.trim();

    const agreementType = selectedSessionID ? "live_auction" : "timed_auction";

    const closeRegistrationModal = useCallback(() => {
        dispatch(
            updateBuyerRegistrationField({
                value: {
                    step: BUYER_REGISTRATION_STEPS.PAYMENT,
                    isBidderRegistrationModalOpen: false,
                },
            })
        );
    }, []);

    useEffect(() => {
        document.body.classList.toggle("modal-open", show);
        return () => {
            document.body.classList.remove("modal-open");
        };
    }, [show]);

    return createPortal(
        <div
            className={`modal fade place-bid-modal emsigner-modal ${show ? "show d-block" : ""}`}
            tabIndex="-1"
            role="dialog"
        >
            <div className="modal-dialog modal-fullscreen modal-dialog-centered ">
                <div
                    className={`modal-content ${agreementSigned ? "pb0" : ""}`}
                >
                    <div className="modal-header">
                        <h5>
                            {t(
                                isBidLimitIncrease
                                    ? "Increase Bidding Limit"
                                    : "BidderRegistration"
                            )}
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={onClose}
                            aria-label="Close"
                        />
                    </div>

                    <div className="modal-body pb0">
                        <EmsignerIframe
                            propertyId={propertyId}
                            agreementType={agreementType}
                            registrationId={registration_id}
                            sessionId={selectedSessionID}
                            currentPath={currentPathName}
                            lotId={lotID}
                            signature={signatureValue}
                            registrationType={registrationType}
                            isBidLimitIncrease={isBidLimitIncrease}
                        />
                        {agreementSigned? (
                            <div className="right clearfix pt20">
                                <button
                                    className="btn btn-primary mr-3"
                                    onClick={onClose}
                                >
                                    {t("Back")}
                                </button>
                                <button
                                    className="btn btn-primary"
                                    onClick={closeRegistrationModal}
                                >
                                    {t("Next")}
                                </button>
                            </div>
                        ) : (
                            <></>
                        )}
                    </div>
                </div>
            </div>
        </div>,
        document.getElementById("root")
    );
};

export default BidderRegistrationAgreementModal;
